export enum UserRole {
  LMNC_ADMIN = "lmncAdmin",
  CLIENT_ADMIN = "policyHubClientAdmin",
  USER = "policyHubUser",
}
